module.exports = __webpack_public_path__ + "static/media/8.03be352a.png";